import * as React from 'react'
import { customerMarketShopfrontApi } from '@envato/foundation-types'

import * as styles from './fullWidthBannerBlock.module.css'

import { IBlockMatchedComponent } from '../../../pages/category/category'
import { reportCategoryPageClick } from '../../../../common/analytics/categoryPageAnalytics'

interface IProps extends IBlockMatchedComponent {
  data: customerMarketShopfrontApi.categoryPage.IFullWidthBannerBlockData
}

const FullWidthBannerBlock = ({ data }: IProps) => {
  const {
    title,
    subtitle,
    buttonText,
    image,
    backgroundColor,
    textColor,
    url
  } = data

  const bannerStyles = {
    backgroundColor,
    color: textColor
  }

  const buttonStyles = { ...bannerStyles, border: '2px solid #0693F8' }

  return (
    <article>
      <a
        href={url}
        style={bannerStyles}
        className={styles.banner}
        onClick={reportCategoryPageClick('Cyber Monday sale full width banner')}
      >
        <div className={styles.imageWrapper}>
          <img className={styles.image} src={image.url} alt={image.alt} />
        </div>
        <div className={styles.detail}>
          <header>
            <h2 className={styles.title}>{title}</h2>
            <h3 className={styles.subtitle}>{subtitle}</h3>
          </header>

          <button style={buttonStyles} className={styles.button}>
            {buttonText}
          </button>
        </div>
      </a>
    </article>
  )
}

export default FullWidthBannerBlock
